import { abortableFetch, useEventCallback } from '@eas/common-web';
import { Task } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useEditTaskDialog() {
  const callApi = useEventCallback((id: string, formData: Task) => {
    return abortableFetch(`${EvidenceApiUrl.TASKS}/${id}`, {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(formData),
    });
  });

  return {
    callApi,
  };
}
